import { render, staticRenderFns } from "./T1Footer.vue?vue&type=template&id=63595a79&scoped=true&"
import script from "./T1Footer.vue?vue&type=script&lang=js&"
export * from "./T1Footer.vue?vue&type=script&lang=js&"
import style0 from "./T1Footer.vue?vue&type=style&index=0&id=63595a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63595a79",
  null
  
)

export default component.exports